// src/pages/hire-expert/DigitalMarketer.jsx
import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "./HireExpert.css";

const DigitalMarketer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}, we’ll contact you soon!`);
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <>
      <Navbar />

      <div className="hire-expert-container">
        {/* Hero Section */}
        <header className="hero-section">
          <h1>Hire Digital Marketers</h1>
          <p>
            Boost your online presence and reach your target audience with our
            expert digital marketers. We specialize in SEO, social media, paid
            campaigns, and data-driven marketing strategies.
          </p>
          <button
            className="cta"
            onClick={() =>
              document
                .getElementById("contact-form")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Book a Call
          </button>
          
        </header>

        {/* Stats Section */}
        <section className="stats">
          <div>
            <h2>32+</h2>
            <p>Countries Served</p>
          </div>
          <div>
            <h2>125+</h2>
            <p>In-house Experts</p>
          </div>
          <div>
            <h2>1870+</h2>
            <p>Projects Delivered</p>
          </div>
          <div>
            <h2>10+</h2>
            <p>Years Experience</p>
          </div>
        </section>

        {/* Tech Stack */}
        <section className="info-section">
          <h2>Marketing Tools & Platforms</h2>
          <ul>
            <li>SEO Tools: SEMrush, Ahrefs, Google Analytics, Moz</li>
            <li>Social Media: Facebook Ads, Instagram, LinkedIn, Twitter</li>
            <li>Email Marketing: Mailchimp, HubSpot, ActiveCampaign</li>
            <li>Ad Platforms: Google Ads, Bing Ads, YouTube</li>
            <li>Automation: Zapier, Hootsuite, Buffer</li>
          </ul>
        </section>

        {/* Best Practices */}
        <section className="info-section">
          <h2>Best Practices We Follow</h2>
          <ul>
            <li>Data-driven marketing strategies</li>
            <li>Targeted audience research & segmentation</li>
            <li>SEO-first content marketing</li>
            <li>Conversion-focused paid campaigns</li>
            <li>Continuous optimization & A/B testing</li>
          </ul>
        </section>

        {/* Services */}
        <section className="info-section">
          <h2>Our Digital Marketing Services</h2>
          <ul className="services-list">
            <li>Search Engine Optimization (SEO)</li>
            <li>Pay-Per-Click (PPC) Campaigns</li>
            <li>Social Media Marketing</li>
            <li>Content Marketing & Strategy</li>
            <li>Email Marketing & Automation</li>
            <li>Influencer & Affiliate Marketing</li>
            <li>Analytics & Reporting</li>
          </ul>
        </section>

        {/* Contact Form */}
        <section id="contact-form" className="contact-section">
          <h2>Book a Call / Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Your Phone"
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Tell us about your project..."
              value={formData.message}
              onChange={handleChange}
              rows="4"
              required
            ></textarea>
            <button type="submit" className="cta">
              Send Message
            </button>
          </form>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default DigitalMarketer;
